<template>
  <div>
    <div class="p-6 pb-0">
      <BreadCrumbs :navigation="navigation" />
      <div class="flex items-center justify-between pt-6">
        <div class="flex items-center gap-4">
          <input v-model="search" type="text" placeholder="Ricerca" class="p93__input_general px-4 py-2" />
        </div>
        <div class="flex items-center gap-2">
          <span class="text-gray-600 text-sm">Aggiornamento tra: {{ remainingSeconds }} secondi</span>
          <button 
            @click="refreshData" 
            class="bg-blue-500 hover:bg-blue-600 text-white px-3 py-1 rounded-md text-sm flex items-center"
            title="Aggiorna ora"
          >
            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
            </svg>
            Aggiorna ora
          </button>
        </div>
      </div>
    </div>
    <div class="p-6 pb-0">
      <table class="min-w-full bg-white rounded-md shadow-lg">
        <thead>
          <tr>
            <th class="py-2 px-4 border-b text-left">Codice</th>
            <th class="py-2 px-4 border-b text-left">Nominativo</th>
            <th class="py-2 px-4 border-b text-left">Azienda</th>
            <th class="py-2 px-4 border-b text-left">Contatto</th>
            <th class="py-2 px-4 border-b text-left">Ingresso</th>
            <th class="py-2 px-4 border-b text-left">Uscita</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in visitors.data" :key="item.id">
            <td class="py-2 px-4 border-b text-left">{{ item.badge }}</td>
            <td class="py-2 px-4 border-b text-left">{{ item.visitor.name }}</td>
            <td class="py-2 px-4 border-b text-left">{{ item.visitor.company }}</td>
            <td class="py-2 px-4 border-b text-left">{{ item.contact?.name ?? '-' }}</td>
            <td class="py-2 px-4 border-b text-left">{{ formatDateTime(item.check_in) }}</td>
            <td class="py-2 px-4 border-b text-left">{{ (item.check_out) ? formatDateTime(item.check_out) : '-' }}</td>
          </tr>
          <tr>
            <td class="text-left" colspan="4"><Pagination :links="visitors.meta.links" /></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { Link, useForm, router } from '@inertiajs/vue3';
import BreadCrumbs from '@/Components/BreadCrumbs.vue';
import Datepicker from 'vue3-datepicker';
import Pagination from '@/Components/Pagination.vue';
import { format, parseISO } from 'date-fns';
import { it } from 'date-fns/locale';

export default {
  props: ['visitors', 'filters'],
  components: {
    Link,
    BreadCrumbs,
    Datepicker,
    Pagination
  },
  data() {
    return {
      search: this.filters?.search || "",
      navigation: [
        { name: 'Dashboard', href: route('dashboard') },
        { name: this.$t('modules.reception-digitale'), href: route('modules.home', 'reception-digitale') },
        { name: 'Real time', href: route('modules.rd-real-time') }
      ],
      dateFormat: 'yyyy-MM-dd',
      refreshInterval: 60, // Intervallo di aggiornamento in secondi
      remainingSeconds: 60, // Contatore iniziale
      timerId: null // Per memorizzare l'ID del timer
    };
  },
  mounted() {
    // Avvia il timer quando il componente viene montato
    this.startRefreshTimer();
  },
  beforeUnmount() {
    // Assicurati di pulire il timer quando il componente viene distrutto
    this.clearRefreshTimer();
  },
  watch: {
    search(value) {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.searchItems(value);
      }, 250);
    }
  },
  methods: {
    formatDate(date) {
      return format(new Date(date), 'dd/MM/yyyy');
    },
    formatDateTime(dateString) {
      if (!dateString) return '';
      try {
        return format(parseISO(dateString), 'dd/MM/yyyy HH:mm', { locale: it });
      } catch (error) {
        return dateString;
      }
    },
    searchItems(value) {
      router.get(route("modules.rd-real-time"), { search: value }, { preserveState: true, replace: true });
    },
    startRefreshTimer() {
      // Pulisci qualsiasi timer esistente
      this.clearRefreshTimer();
      
      // Imposta il contatore iniziale
      this.remainingSeconds = this.refreshInterval;
      
      // Crea un timer che decrementa il contatore ogni secondo
      this.timerId = setInterval(() => {
        this.remainingSeconds--;
        
        // Quando il contatore arriva a zero, aggiorna i dati e reimposta il timer
        if (this.remainingSeconds <= 0) {
          this.refreshData();
        }
      }, 1000);
    },
    clearRefreshTimer() {
      if (this.timerId) {
        clearInterval(this.timerId);
        this.timerId = null;
      }
    },
    refreshData() {
      // Aggiorna i dati
      router.reload({ only: ['visitors'], preserveScroll: true, onSuccess: () => {
        // Dopo l'aggiornamento riuscito, reimposta il timer
        this.startRefreshTimer();
      }});
    }
  }
};
</script>

<style>
/* Aggiungi eventuali stili specifici qui */
</style>